import { cn, getColorway } from 'utils/styles';
import { StarFilled } from '@1debit/icons';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { SharedBentoBoxCardProps } from 'types/sharedComponents';
import { getColorwayName } from 'utils/formatters';
import { Colorways } from 'types/constants';

interface Props extends SharedBentoBoxCardProps {
  stars: string;
}

const BentoBoxAppReviewCard = ({ color, cardHeadlineRte, copy, stars }: Props) => {
  const isReserveColorway = getColorwayName(color) === Colorways.Reserve;

  return (
    <div className={`md:aspect-2/1 rounded-lg p-6 font-sans ${getColorway(color)}`}>
      <p
        className={cn('font-[670] text-[32px] flex items-center gap-2', {
          'text-bg-action-primary': isReserveColorway,
        })}>
        {stars} <StarFilled className={'inline-block h-[32px]'} />
      </p>
      <div className="text-body-saans">
        <div className="font-bold">
          <RichTextCopy copy={cardHeadlineRte} />
        </div>
        {copy && (
          <div className="font-medium">
            <RichTextCopy copy={copy} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BentoBoxAppReviewCard;
